// eslint-disable-next-line max-len
export var isLoggedIn = function isLoggedIn(state) {
  return state.isLoggedIn;
};
export var getAccessToken = function getAccessToken(state) {
  return state.user.accessToken;
};